<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Scan Period</h2>
        <p class="srm-sub">When the gate accepts scans</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-field">
        <span class="srm-label">Period type</span>
        <div class="srm-toggle" role="tablist">
          <button type="button" class="srm-toggle-btn"
                  [class.srm-toggle-btn--active]="mode === 'offset'"
                  (click)="setMode('offset')">Offset time</button>
          <button type="button" class="srm-toggle-btn"
                  [class.srm-toggle-btn--active]="mode === 'specific'"
                  (click)="setMode('specific')">Specific time</button>
        </div>
      </div>

      <ng-container *ngIf="mode === 'offset'">
        <div class="srm-field">
          <span class="srm-label">Start (relative to event time)</span>
          <div class="srm-stepper">
            <button type="button" class="srm-stepper-btn" (click)="stepOpen(-15)">−</button>
            <span class="srm-stepper-value">{{ offsetLabel(openValue) }}</span>
            <button type="button" class="srm-stepper-btn" (click)="stepOpen(15)">+</button>
          </div>
        </div>
        <div class="srm-field">
          <span class="srm-label">End (relative to event time)</span>
          <div class="srm-stepper">
            <button type="button" class="srm-stepper-btn" (click)="stepClose(-15)">−</button>
            <span class="srm-stepper-value">{{ offsetLabel(closeValue) }}</span>
            <button type="button" class="srm-stepper-btn" (click)="stepClose(15)">+</button>
          </div>
        </div>
        <p class="srm-hint">Negative is before event time. Steps of 15 minutes.</p>
      </ng-container>

      <ng-container *ngIf="mode === 'specific'">
        <div class="srm-field">
          <span class="srm-label">Start</span>
          <input type="datetime-local" class="srm-input"
                 [value]="toDateTimeLocal(openValue)"
                 (change)="setOpenDateTime($any($event.target).value)" />
        </div>
        <div class="srm-field">
          <span class="srm-label">End</span>
          <input type="datetime-local" class="srm-input"
                 [value]="toDateTimeLocal(closeValue)"
                 (change)="setCloseDateTime($any($event.target).value)" />
        </div>
      </ng-container>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
